import { render, staticRenderFns } from "./publicList.vue?vue&type=template&id=db451372&scoped=true"
import script from "./publicList.vue?vue&type=script&lang=js"
export * from "./publicList.vue?vue&type=script&lang=js"
import style0 from "./publicList.vue?vue&type=style&index=0&id=db451372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db451372",
  null
  
)

export default component.exports